import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import store from './store';
import router from './router'
import helper from './helper/helper';
import './bootstrap';

Vue.config.productionTip = false;

Vue.mixin(helper);

Vue.use(Vuex);
Vue.mixin({store});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
